import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';

export default function BlackoutProtection() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanPlus.BlackoutProtection');
    const iconList = [
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049119049/icon1.svg',
            text: t('icon1'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049119379/icon2.svg',
            text: t('icon2'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049119900/icon3.svg',
            text: t('icon3'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049121348/icon4.svg',
            text: t('icon4'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049121166/icon5.svg',
            text: t('icon5'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049121054/icon6.svg',
            text: t('icon6'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049120895/icon7.svg',
            text: t('icon7'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049120500/icon8.svg',
            text: t('icon8'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049120306/icon9.svg',
            text: t('icon9'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049120099/icon10.svg',
            text: t('icon10'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049119192/icon11.svg',
            text: t('icon11'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049119729/icon12.svg',
            text: t('icon12'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049119571/icon13.svg',
            text: t('icon13'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769049121574/icon14.svg',
            text: t('icon14'),
        },
    ];
    return (
        <div className={`${styles.blackoutProtection}`}>
            <div className="solution-item">
                <div className="text-box">
                    <div className="sub-title">{t('label')}</div>
                    <h2 className="title">{t('title')}</h2>
                    <div className="desc">{t('desc')}</div>
                    <div className="worp">
                        <h3 className="worp-item">
                            <span className="item-title first-item-title">{t('item_title1')}</span>
                            <span className="item-desc">{t('item_desc1')}</span>
                        </h3>
                        <h3 className="worp-item">
                            <span className="item-title">{t('item_title2')}</span>
                            <span className="item-desc">{t('item_desc2')}</span>
                        </h3>
                        <h3 className="worp-item">
                            <span className="item-title">{t('item_title3')}</span>
                            <span className="item-desc">{t('item_desc3')}</span>
                        </h3>
                    </div>
                </div>
                <div className="container">
                    <div className="bg-img">
                        <EcoImg
                            pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718086612215/pc-tuya.jpg"
                            pad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718086617652/mo-tuya.jpg"
                            alt={t('title')}
                        />
                    </div>

                    <div className="right-box">
                        <div className="icon-box">
                            <div className="box-title">{t('icon_title')}</div>
                            <div className="icon-content">
                                {iconList.map((item, index) => {
                                    return (
                                        <div className="icon-item" key={index}>
                                            <div className="icon-img">
                                                <EcoImg pc={item.icon} alt={item.text} />
                                            </div>
                                            <div className="icon-text">{item.text}</div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="tips">{t('icon_desc')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
